import React, { useState } from 'react'
import { Box, Tabs, Tab } from '@mui/material'
import CustomerPanel from './CustomerPanel'
import OrderPanel from './OrderPanel'
import { IFacebookChatRoom } from '../../../types/facebook'
import OrderHistoryTable from './OrderHistoryTable'
interface Props {
  isOpenedCustomerPanel: boolean
  chatRoom?: IFacebookChatRoom | null
  mutate: () => void
}
const ChatCustomerPanel = (props: Props) => {
  const { isOpenedCustomerPanel, chatRoom, mutate } = props
  const [activeTab, setActiveTab] = useState<number>(0)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
  }

  return (
    <Box
      sx={{
        display: isOpenedCustomerPanel ? 'block' : 'none',
        height: '100%',
        overflow: 'hidden',
        width: '100%',
      }}
    >
      <Tabs value={activeTab} onChange={handleTabChange} variant="fullWidth">
        <Tab label="ข้อมูล" />
        <Tab label="สร้างคำสั่งซื้อ" />
        <Tab label="ประวัติคำสั่งซื้อ" />
      </Tabs>
      <Box p={1} sx={{ height: 730, overflowY: 'auto' }}>
        {activeTab === 0 && (
          <CustomerPanel mutate={mutate} chatRoom={chatRoom} />
        )}
        {activeTab === 1 && <OrderPanel chatRoom={chatRoom} />}
        {activeTab === 2 && <OrderHistoryTable chatRoom={chatRoom} />}
      </Box>
    </Box>
  )
}

export default ChatCustomerPanel
